/**
 * @author: addyxu,zimyuan
 * @last-edit-date: 2016-08-29
 */


/**
 * @function Share
 * @param {Object} data                 - 传入的分享设置对象
 * @param {string} data.img_url         - 分享的图片地址
 * @param {string} data.img_width       - 分享的图片宽度
 * @param {string} data.img_height      - 分享的图片高度
 * @param {string} data.link            - 分享的链接地址
 * @example
    var data = {
        img_url   : 'http://km.oa.com/files/groups/icons/23825.jpg',
        img_width : '108',
        img_height: '108',
        link      : location.href + '#wechat_redirect',
        desc      : 'test share',
        title     : 'test title'
    };
    var friendCircleTitle = '朋友圈标题';
    function shareCbk(result, type) {
        if ( result === 0 && type === 0 ) {
            alert('分享给好友成功');
        }
        if ( result === 0 && type === 1 ) {
            alert('分享到朋友圈成功');
        }
    }
    Share(data, shareCbk, friendCircleTitle);
 */

/**
 * 为链接添加ssid
 */
import Dom from '../base/mdom.js';

import ajaxcall from '../common/ajaxcall.js';
import * as mbase from '../base/mbase.js';
import * as Strings from '../base/string.js';
import { beforeInvoke } from "./jsbridge_hook";
function autoAppendSsid(link, ssid) {
    if ( link.indexOf('ssid=') > -1 )
        return link;

    if ( link.indexOf('?') > -1 )
        return link.replace('?', '?ssid=' + ssid + '&');

    if ( link.indexOf('#wechat_redirect') > -1 )
        return link.replace(
                            '#wechat_redirect',
                            '?ssid=' + ssid + '#wechat_redirect'
                           );

    return link + '?ssid=' + ssid;
}

function appendShareOpenid(link,share_openid){
    link = link || '';

    var srcQuery = Strings.getQuery(link);
    var srcHash  = Strings.getHash(link);
    if( share_openid ){
        /** 这句话会兼容 以下情况。
         * 1、link里本来就有share_openid，于是会替换它的value
         * 2、link里没有这个share_openid，于是会新增一个。
         */
        srcQuery.share_openid = share_openid;
    }

    var newUrl = [];
    /**添加 上domain */
    newUrl.push(Strings.getDomainPath(link));
    /** 添加 上整个 */
    var query = Strings.mapToStr(srcQuery) || '';
    if( query.length <= 0){
        return newUrl.join('');
    }

    newUrl.push('?');
    newUrl.push(query);
    if( srcHash ){
        newUrl.push('#' + srcHash);
    }
    return newUrl.join('');
}
function getShareOpenID(cbk){

    var cgi = '/cgi-bin/gamecenterwap/getgamecenterdata';
    ajaxcall(
        cgi,
        JSON.stringify({
            method: 'POST',
            "user_info_option": {
                "need": true
            }
        }),
        function(res){
            var share_openid = mbase.getValue(
                res,
                'data.user_info.openid'
            )+'';
            if( share_openid && share_openid.length > 0){
                cbk && cbk(true,share_openid);
            }else{
                cbk && cbk(false,'fail_get_openid');
            }

        },function(fail_res){
            if( Dom.window.logError ){
                Dom.window.logError('getShareOpenID','get_shareopenid_fail');
            }
            cbk && cbk(false,'cgierror');
        }
    )
}
/**
 * 分享组件
 * @param {Object} data: 分享配置
 * @param {Function} callback: 分享回调函数
 * @param {String} friendCircleTitle: 分享到朋友圈的标题
 */
function Share(data, callback, friendCircleTitle) {

    // 支持传递appid=false，不设置小尾巴
    if( data.appid === false ) {
        data.appid = '';
    }else {
        data.appid = data.appid || 'wx62d9035fd4fd2059';
    }

    var link   = data.link  || '';

    if (!Dom.window.WeixinJSBridge) {

        Dom.window.document.addEventListener('WeixinJSBridgeReady', function () {
            Share(data, callback, friendCircleTitle);
        });
        return;
    }

    data.link   = autoAppendSsid(link, 1);
    Dom.window.WeixinJSBridge &&
    Dom.window.WeixinJSBridge.on('menu:share:appmessage', function (res) {
        getShareOpenID(async function(flag,share_openid){
            var tlink = data.link;
            if( true === flag ){
                tlink   = appendShareOpenid(data.link,share_openid);
            }else{
                console.log('getShareOpenID fail',share_openid);
            }

            data.link   = tlink;
            await beforeInvoke('sendAppMessage', data);
            Dom.window.WeixinJSBridge &&
            Dom.window.WeixinJSBridge.invoke(
                'sendAppMessage',
                data,
                function (res) {
                    if (   res
                        && (   res.err_msg.indexOf(':confirm') != -1
                            || res.err_msg.indexOf(':ok') != -1 ) ) {
                        callback && callback(0, 0);
                    }

                    else if (   res
                            && res.err_msg.indexOf(':cancel') != -1 ) {
                        callback && callback(-1);
                    }else {
                        callback && callback(-2, res);
                    }
                }
            );
        });
    });

    var circleData = JSON.parse(JSON.stringify(data));

    if ( friendCircleTitle )
        circleData.title = friendCircleTitle;


    circleData.link = autoAppendSsid(link, 4);
    Dom.window.WeixinJSBridge &&
    Dom.window.WeixinJSBridge.on('menu:share:timeline', function (res) {

        getShareOpenID(async function(flag,share_openid){
            var tlink = circleData.link;

            if( true === flag ){
                tlink   = appendShareOpenid(circleData.link,share_openid);
            }else{
                console.log('getShareOpenID fail',share_openid);
            }
            circleData.link   = tlink;
            await beforeInvoke('shareTimeline', circleData);
            Dom.window.WeixinJSBridge &&
            Dom.window.WeixinJSBridge.invoke(
                'shareTimeline',
                circleData,
                function (res) {
                    if (   res
                        && (   res.err_msg.indexOf(':ok') != -1
                            || res.err_msg.indexOf(':confirm') != -1 ) ) {
                        callback && callback(0, 1);
                    }

                    else if (   res
                            && res.err_msg.indexOf(':cancel') != -1 ) {
                        callback && callback(-1);
                    }else {
                        callback && callback(-2, res);
                    }
                }
            );
        });
    });
}

export default Share;
